import { IconButton, Tooltip, Box, Typography } from '@mui/material';
import React from 'react';
import { FunctionField, Link } from 'react-admin';
import { InfoOutlined } from '@mui/icons-material';

const MultipleHospitalMarkupTooltip = ({ state_hospital_mark_up, position_id }) => {
  return (
    <Tooltip
      arrow
      title={
        <Box display="flex" flexDirection="column">
          {state_hospital_mark_up.map((item, index) => {
            const isLastItem = index === state_hospital_mark_up?.length - 1;
            const statesNames = isLastItem
              ? 'All other states'
              : item.states?.map((state) => state.name).join(', ');
            const markupPercentage = Math.round(parseFloat(item.location_type_markup || 0) * 100);

            return (
              <Typography key={`${item.id}-${index}`} variant="body2">
                {statesNames}: {markupPercentage}%
              </Typography>
            );
          })}
        </Box>
      }
      placement="top"
    >
      <Box display="flex" alignItems="center" width={'fit-content'}>
        <Link
          to={`/StateLocationTypePositionRateSetting?filter={"position_id":${position_id}, "location_type_id": 8}`}
        >
          Refer to SLTPRS
        </Link>
        <IconButton color="primary" size="small">
          <InfoOutlined />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

const PositionHospitalMarkupField = () => {
  return (
    <FunctionField
      render={(record) => {
        const { state_hospital_mark_up } = record;
        if (!state_hospital_mark_up?.length) {
          return '';
        }

        if (state_hospital_mark_up?.length > 1) {
          return (
            <MultipleHospitalMarkupTooltip
              state_hospital_mark_up={state_hospital_mark_up}
              position_id={record.id}
            />
          );
        }

        return `${Number(
          ((state_hospital_mark_up[0]?.location_type_markup || 0) * 100).toFixed(2),
        )}%`;
      }}
    />
  );
};

PositionHospitalMarkupField.defaultProps = {
  label: 'State Hospital Markup',
};

export default PositionHospitalMarkupField;
